export const USIA_GERIATRI_MIN = 60;

export function usiaTahun(tglLahir?: string | null): number | null {
  if (!tglLahir) return null;
  const parts = tglLahir.split("-");
  const lahir =
    parts.length === 3
      ? new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]))
      : new Date(tglLahir);
  if (isNaN(lahir.getTime())) return null;

  const now = new Date();
  let usia = now.getFullYear() - lahir.getFullYear();
  const m = now.getMonth() - lahir.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < lahir.getDate())) {
    usia--;
  }
  return usia;
}

export function isUsiaGeriatri(tglLahir?: string | null): boolean {
  const usia = usiaTahun(tglLahir);
  return usia !== null && usia >= USIA_GERIATRI_MIN;
}
